import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HistInfo, RechtsgrundEntryMeta } from '../../../core/gb-api';
import { TranslateNamePipe } from '../../pipes/simple/translate-name.pipe';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { RechtsgrundLocation } from '../../services/location-strategy/rechtsgrund-location-strategy';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { ErweiterungConfigResponse } from '../../../core/base-api';
import { KompaktBelegComponent } from '../beleg/kompakt-beleg.component';
import { HistoryDirective } from '../../directives/history.directive';
import { ReadMoreComponent } from '../../widgets/read-more/read-more.component';
import { KompaktTimepointComponent } from '../timepoint/kompakt-timepoint.component';
import { Subscription } from 'rxjs';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-rechtsgrund',
  templateUrl: './rechtsgrund.component.html',
  styleUrls: ['./rechtsgrund.component.scss'],
  providers: [{ provide: ComponentLocationStrategy, useClass: RechtsgrundLocation }],
  imports: [KompaktBelegComponent, HistoryDirective, ReadMoreComponent, KompaktTimepointComponent]
})
export class RechtsgrundComponent implements OnInit, OnDestroy {
  @Input()
  rechtsgrund: RechtsgrundEntryMeta;
  @Input()
  textLimit = 40;
  @Input()
  ohneLoeschgeschaeft = false;

  text: string;
  isGeschaeftsmodulCapWebErweiterung: boolean;
  private _histInfo: HistInfo;
  private subscription: Subscription = new Subscription();

  constructor(
    private translateName: TranslateNamePipe,
    private appFormatConfigService: FormatConfigService
  ) {}

  ngOnInit() {
    const rechtsgrundCode =
      this.rechtsgrund.rechtsgrundCode && this.rechtsgrund.rechtsgrundCode.text
        ? this.translateName.transform(this.rechtsgrund.rechtsgrundCode.text)
        : '';
    this.text = rechtsgrundCode + (this.rechtsgrund.rechtsgrundZusatz ? ' ' + this.rechtsgrund.rechtsgrundZusatz : '');
    this.subscription.add(
      this.appFormatConfigService.erweiterungsConfig$.subscribe((config) => {
        this.isGeschaeftsmodulCapWebErweiterung = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.GESCHAEFTSMODUL_CAP_WEB);
      })
    );
  }

  get histInfo(): HistInfo {
    return this._histInfo ? this._histInfo : this.rechtsgrund.histInfo;
  }

  @Input()
  set histInfo(value: HistInfo) {
    this._histInfo = value;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
